import { ExternalToolKey } from "./tool";

export enum ProductDetailsAdvertiser {
  Alteos = ExternalToolKey.Alteos,
  ZegPlusGarantie = ExternalToolKey.ZegPlusGarantie
}

export type AdvertiserArea = "productDetailsWidget" | "productPrintDataSheet";
